import React, { useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function PagesError() {
	const context = useContext(AppSettings);
	
	useEffect(() => {
		context.setAppHeaderNone(true);
		context.setAppSidebarNone(true);
		context.setAppContentClass('p-0');
		
		return function cleanUp() {
			context.setAppHeaderNone(false);
			context.setAppSidebarNone(false);
			context.setAppContentClass('');
		};
		
		// eslint-disable-next-line
	}, []);

	return (
		<div className="error-page">
			<div className="error-page-content">
				<div className="error-code">404</div>
				
				<h1 className="mb-3">¡Oops!</h1> 
				<h3 className="mb-3">Parece que no tienes permiso para acceder a este modulo</h3>
				{/* <p className="mb-2">
					Here are some helpful links instead:
				</p> */}
				<Link to="/pages/login" className="btn btn-theme w-130px text-uppercase btn-sm py-2 fs-11px">Volver al inicio</Link>
			</div>
		</div>
	)
}

export default PagesError;